<template>
  <pt-obs-department-detail class="pt-obs-department-detail__page" :id="id" :isEdit="is_edit"></pt-obs-department-detail>
</template>

<script>
import PtObsDepartmentDetail from 'cps/obs-department/pt-obs-department-question/pt-obs-department-detail/withData'
export default {
  name: 'pt-obs-department-detail__view',
  props: {
    id: String,
    isEdit: String
  },
  components: {
    'pt-obs-department-detail': PtObsDepartmentDetail
  },
  data () {
    return {
      is_edit: this.isEdit === 'true'
    }
  }
}
</script>
